import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';

export class ViewportControls extends THREE.Controls {
    constructor(object, domElement) {
        super( object, domElement );

    }
    follow( link ) {
        this.link = link;
        // console.log(this.link);
        this.object.lookAt( this.link.position );
        this.v = new THREE.Vector3();
        this.v.subVectors( this.object.position, this.link.position );
    }

    update( deltaTime = null) {
        if (this.link) {
            this.object.position.copy( this.link.position.clone().add( this.v ) );
        }
    }
}